export default __webpack_public_path__ + "e2367b17f874b9cf522a48336a7fc86f.svg";